import React, { useEffect, useState, useRef } from 'react';
import API from '../../../create/api';
import { CircularProgress, IconButton, Box } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

const CurrentBalance = () => {
  const [balance, setBalance] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const isMounted = useRef(true);

  const fetchBalance = async () => {
    setLoading(true);
    // Add fake 2 second delay for refresh
    await new Promise((resolve) => setTimeout(resolve, 2000));

    try {
      const response = (await API.getAll(`${process.env.REACT_APP_API_SERVER}/balances/current`)) as {
        balance: number;
      };
      if (isMounted.current) setBalance(response.balance);
    } catch (error) {
      if (isMounted.current) console.error('Error fetching balance:', error);
    } finally {
      if (isMounted.current) setLoading(false);
    }
  };

  useEffect(() => {
    isMounted.current = true;
    fetchBalance();
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      display="flex"
      alignItems="center"
      borderRadius={20}
      px={2}
      py={0.5}
      boxShadow={1}
      mr={2}
      style={{ height: 36 }}
      className="bg-white"
    >
      <span
        className={loading ? 'animate-pulse font-semibold text-gray-600 mr-2' : 'font-semibold text-gray-900 mr-2'}
        style={{ display: 'inline-block' }}
      >
        Balance: {balance !== null ? `${balance}/-` : '0/-'}
      </span>
      <IconButton
        size="small"
        onClick={() => fetchBalance()}
        aria-label="refresh"
        style={{ color: '#388e3c' }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={20} style={{ color: '#388e3c' }} /> : <RefreshIcon fontSize="small" />}
      </IconButton>
    </Box>
  );
};

export default CurrentBalance;
